import { t } from 'i18next';

export { PortalChannelType } from './dataTypes/portalConfigTypes';

export const DEFAULT_FILTER_RESULTS_LIMIT = 5;

export const COMPANY_TYPE = 'company';
export const CLIENT_TYPE = 'client';
export const TEAM_TYPE = 'team';

type GroupOptionMap = {
  [key in channelMemberOptionTypes]: string;
};

export type channelMemberOptionTypes =
  | 'text'
  | 'client'
  | 'company'
  | 'title'
  | 'no-option';

export const getGroupOptionMapper = (): GroupOptionMap =>
  ({
    company: t(($) => $.constants.recent_companies),
    client: t(($) => $.constants.recent_clients),
    title: '',
    'no-option': '',
    text: '',
  }) as const;

export const isGroupOption = (key: string): key is keyof GroupOptionMap =>
  typeof key === 'string' &&
  (
    [
      'company',
      'client',
      'title',
      'no-option',
      'text',
    ] satisfies channelMemberOptionTypes[]
  ).includes(key as channelMemberOptionTypes);

export type GroupType = 'company' | 'team' | 'client';
